import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import Navbar from "./Header/Navbar";
import AuthHeader from "./Header/AuthHeader";
import TopBar from "./Header/TopBar";
import Footer from "./Footer";
import { useUser } from "@/contexts/UserContext";

export default function MainLayout({ children }) {
  const { user } = useUser();
  const isAuthenticated = Boolean(user);

  return (
    <Flex flexDir="column" minH="100vh">
      <Box
        as="a"
        href="#main-content"
        position="absolute"
        left="-9999px"
        top={0}
        zIndex={9999}
        bg="white"
        color="primary.800"
        px={4}
        py={2}
        textStyle="body.semibold"
        _focusVisible={{ left: 2, top: 2 }}
      >
        Անցնել հիմնական բովանդակությանը
      </Box>
      {isAuthenticated ? <AuthHeader /> : <Navbar />}
      {isAuthenticated && <TopBar />}
      <Box as="main" id="main-content" tabIndex={-1} flex="1" w="full" _focus={{ outline: "none" }}>
        {children}
      </Box>
      <Footer />
    </Flex>
  );
}
